import { cnapexApiRawFetch } from "@/lib/api/fetcher";
import type { Answer } from "@/features/game/components/style-quiz/types";

export interface ApexStyleAnalysisInput {
  selectedPosition: number;
  answers: Answer[];
}

export function analyzeApexStyle(input: ApexStyleAnalysisInput) {
  return cnapexApiRawFetch("/api/apex/style-analysis", {
    method: "POST",
    headers: {
      Accept: "text/plain",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(input),
  });
}
